/* global Swiper */
/* global Drift */

Wee.fn.make('productEntry', {
	init: function() {
		var $priv = this.$private,
			$productInfo = $('ref:productInfo'),
			$modal = $('ref:productModal');

		$priv.initSwipers();
		$priv.initEvents();
		$priv.initDrift(0, $('.swiper-slide-active'));

		if ($('ref:weeDropdown').length) {
			Wee.dropdown.init({
				placeholder: false,
				isSelected: true,
				rootModifier: '-product',
				visibleItems: 999
			});
		}

		$.screen.map([
			{
				max: 2,
				callback: function() {
					$productInfo.remove();
					$('ref:productDescription').before($productInfo);
				}
			},
			{
				min: 3,
				callback: function() {
					$productInfo.remove();

					if ($('ref:relatedMedia').length === 0) {
						$('ref:similarProducts').before($productInfo);
					} else {
						$('ref:relatedMedia').before($productInfo);
					}
				}
			},
			{
				max: 3,
				callback: function() {
					$('ref:productGallery').after($modal);
					$('ref:swiperSlideTitle').remove();
				}
			},
			{
				min: 4,
				callback: function() {
					$('ref:productModal').remove();
				}
			}
		]);
	},

	unload: function() {
		$.events.off(false, '.productEntry');
		this.$private.swiper1.destroy();
		this.$private.swiper3.destroy();

		if (this.$private.swiper2) {
			this.$private.swiper2.destroy();
		}

		this.$private.drift.destroy();
	}
}, {
	initSwipers: function() {
		var scope = this,
			relatedImages = $.get('relatedImages');

		this.swiper1 = new Swiper('.swiper1', {
			nextButton: '.swiper-button-next',
			prevButton: '.swiper-button-prev',
			pagination: '.swiper-pagination',
			paginationClickable: true,
			loop: true,
			autoHeight: true
		});

		if (relatedImages) {
			this.swiper2 = new Swiper('.swiper2', {
				nextButton: '.swiper-button-next2',
				prevButton: '.swiper-button-prev2',
				pagination: '.swiper-pagination2',
				paginationClickable: true,
				loop: true
			});
		}

		this.swiper3 = new Swiper('.swiper3', {
			nextButton: '.swiper-button-next3',
			prevButton: '.swiper-button-prev3',
			loop: true
		});

		this.swiper1.on('imagesReady', function(instance) {
			scope.swiper1.slideTo(instance.activeIndex);
		});

		// Synchronize swiper active slides
		this.swiper1.on('slideChangeStart', function(instance) {
			scope.activateThumbnail(instance.realIndex, $('ref:thumbnailWrapper'));
			scope.initDrift(instance.activeIndex, $('.swiper-slide-active'));
			scope.swiper3.slideTo(instance.activeIndex);
		});

		if (relatedImages) {
			this.swiper2.on('slideChangeStart', function(instance) {
				scope.activateThumbnail(instance.realIndex, $('ref:mediaThumbnailWrapper'));
			});
		}

		this.swiper3.on('slideChangeStart', function(instance) {
			scope.swiper1.slideTo(instance.activeIndex);
		});
	},

	/**
	 * Init Drift instance
	 *
	 * @private
	 */
	initDrift: function(index, el) {
		if (! $(el).hasClass('-video')) {
			this.drift = new Drift($('ref:productSwiperItem')[index], {
				inlinePane: true,
				zoomFactor: 2
			});
		}
	},

	/**
	 * Init events
	 *
	 * @private
	 */
	initEvents: function() {
		var scope = this;

		$.events.on({
			'ref:productBlockCollapse': {
				click: function(e, el) {
					var $el = $(el),
						$productBlock = $el.closest('ref:productBlock'),
						$list = $('ref:collapsibleList', $productBlock),
						collapsed = '-collapsed';

					if ($productBlock.hasClass(collapsed)) {
						$productBlock.removeClass(collapsed)
							.find($list)
							.attr('aria-expanded', true);
						$el.text('Collapse');
					} else {
						$productBlock.addClass(collapsed)
							.find($list)
							.attr('aria-expanded', false);
						$el.text('Expand');
					}
				}
			},

			'ref:share': {
				click: function() {
					$('ref:productShare').toggleActive();
				}
			},

			'ref:addToQuote': {
				click: function(e) {
					var $quoteButton = $('ref:addToQuote');

					$(this).html('<span class="spinner"></span>').addClass('spin');

					setTimeout(function() {
						$quoteButton
							.text('Success')
							.removeClass('spin')
							.addClass('success');

						setTimeout(function() {
							$('.spinner').remove();
						}, 500);
					}, 1000);

					$quoteButton[0].disabled = true;

					e.preventDefault();
				}
			},

			'ref:swiperPagination': {
				click: function() {
					$('ref:thumbnailGallery').scrollTop(
						$('.product-gallery__thumb-wrapper.-active').data('index') * 84
					);
				}
			},

			'ref:relatedMediaPagination': {
				click: function(e, el) {
					scope.scrollThumbnailsHorizontal(el);
				}
			},

			'ref:swiperWrapper': {
				click: function() {
					scope.showModal();
				}
			},

			'ref:modalClose': {
				click: function() {
					scope.closeModal();
				}
			},

			'ref:thumbnail': {
				click: function(e, el) {
					var $el = $(el),
						index = $el.data('index');

					scope.activateThumbnail(index, $('ref:thumbnail'));
					scope.scrollToProductImage(el, index);
				}
			}
		}, {
			namespace: 'productEntry'
		});
	},

	/**
	 * Give thumbnail active class
	 *
	 * @private
	 */
	activateThumbnail: function(index, ref) {
		ref.each(function() {
			var $this = $(this);

			$this.deactivate();

			if ($this.data('index') === index) {
				$this.activate();
			}
		});
	},

	/**
	 * Scroll thumbnails left or right depending on pagination
	 *
	 * @pagination
	 */
	scrollThumbnailsHorizontal: function(el) {
		var $thumbContainer = $('ref:thumbnailMedia'),
			thumbnailLeft = $thumbContainer.scrollLeft();

		if ($(el).data('direction') === 'next') {
			thumbnailLeft = thumbnailLeft + 84;
			$thumbContainer.scrollLeft(thumbnailLeft);

			if ($('ref:mediaThumbnailWrapper').eq(0).isActive()) {
				$thumbContainer.scrollLeft(0);
			}
		} else {
			thumbnailLeft = thumbnailLeft - 84;
			$thumbContainer.scrollLeft(thumbnailLeft);
		}
	},

	/**
	 * Show modal product image gallery
	 *
	 * @private
	 */
	showModal: function() {
		var activeTitle = $('.swiper-slide-active').data('title');

		$('ref:productModal').css({
			'height': '100vh',
			'opacity': '1',
			'width': '100vw',
			'z-index': '999'
		});

		$('ref:thumbnailWrapper').each(function() {
			var $this = $(this);

			if ($this.data('title') === activeTitle) {
				$this.activate();
			}
		});
	},

	/**
	 * Close modal window
	 *
	 * @private
	 */
	closeModal: function() {
		$('ref:productModal').css({
			'opacity': '0',
			'z-index': '-1'
		});
	},

	/**
	 * Scroll product image swiper when thumbnail is selected
	 *
	 * @private
	 */
	scrollToProductImage: function(el, index) {
		if ($(el).eq(0).hasClass('-related')) {
			this.swiper2.slideTo(index + 1);
		} else {
			this.swiper1.slideTo(index + 1);
		}
	}
});
